import { Directive, Output, EventEmitter, Input, SimpleChange} from '@angular/core';

@Directive({
    selector: '[onCreate]',
    standalone: false
})
export class OnCreate {

  @Output() onCreate: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}
  ngOnInit() {    
     this.onCreate.emit('');// this is not for testing do not delete; 
  } 

}
